import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { LoadableFallback } from 'components/Common/LoadableFallback';

const UsefulInfo = loadable(() => import(/* webpackChunkName: "UsefulInfo" */ './UsefulInfo'), {
  fallback: <LoadableFallback visible />,
});

const asyncUsefulInfo = ({ route }) => (
  <UsefulInfo route={route} />
);

asyncUsefulInfo.propTypes = {
  route: PropTypes.object.isRequired,
};

export default asyncUsefulInfo;
